import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { AppErrorBoundary } from './app/error-boundary';
import { AppProviders } from './app/providers';
import './styles/globals.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('#root bulunamadı.');
}

createRoot(container).render(
  <StrictMode>
    {/* Hata sınırı en dışta: sağlayıcılar patlasa bile beyaz ekran olmaz. */}
    <AppErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </AppErrorBoundary>
  </StrictMode>,
);
